import React from 'react';
import Select from 'react-select'

function FormBirthday({name, label, sublabel, register, control, ...otherProps}) {

    var {birthday} = otherProps;
    var {error} = otherProps;
    const invalidStyle = {width: "100%", marginTop: "0.25rem", fontSize: "80%", color: "#ff4136"}

    // YYYY-MM-DD
    if (birthday && birthday.split("-").length === 3) {
        const temp = birthday
        birthday = {}
        birthday.year = temp.split("-")[0]
        birthday.month = temp.split("-")[1]
        birthday.day = temp.split("-")[2]
    } else {
        birthday = {}
    }
    
    function range(start, end) {
        return Array(end - start + 1).fill().map((_, idx) => start + idx)
    }
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    const monthOptions = months.map((val, idx) => {
        // console.log(idx)
        return {label: val, value: ("0" + String(idx+1)).slice(-2)}
    })

    const days = range(1,31)
    // [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]
    const dayOptions = days.map((val) => {
        return {label: String(val), value: ("0" + String(val)).slice(-2)}
    })

    const years = range(1900, 2020).reverse()
    const yearOptions = years.map((val) => {
        return {label: String(val), value: String(val)}
    })

    const [month, setMonth] = React.useState(monthOptions.find(val => { return val.value === birthday.month}))
    const [day, setDay] = React.useState(dayOptions.find(val => { return val.value === birthday.day}))
    const [year, setYear] = React.useState(yearOptions.find(val => { return val.value === birthday.year}))

    const updateSelection = (month, day, year) => {
        if (otherProps.onChange && month && day && year) {
            const birthday = `${year.value}-${month.value}-${day.value}`
            otherProps.onChange(birthday)
        }
        
    }
    const handleMonthChange = (option) => {
        console.log(option.value)
        setMonth(option)
        updateSelection(option, day, year)
    }

    const handleDayChange = (option) => {
        console.log(option.value)
        setDay(option)
        updateSelection(month, option, year)
    }

    const handleYearChange = (option) => {
        console.log(option.value)
        setYear(option)
        updateSelection(month, day, option)
    }

    const {fullSize} = otherProps;
    const leftCol = fullSize ? "col-md-3" : "col-md-2"
    const rightCol = fullSize ? "col-md-3" : "col-md-2"

    return (
    <div className="form-group row">
        {label && (<label className={`${leftCol} col-form-label`}>
            <h6>{label}</h6>
            {sublabel && (<small>{sublabel}</small>)}
        </label>)}

        <div className={`${rightCol} mb-2`}>
            <Select
            value={month}
            placeholder="Month"
            options={monthOptions}
            onChange={handleMonthChange}
            />
        </div>
        <div className={`${rightCol} mb-2`}>
            <Select
            value={day}
            placeholder="Day"
            options={dayOptions}
            onChange={handleDayChange}
            />
        </div>
        <div className={`${rightCol} mb-2`}>
            <Select
            value={year}
            placeholder="Year"
            options={yearOptions}
            onChange={handleYearChange}
            />
        </div>
        {error && (
            <div style={invalidStyle}>
                {error.message}
            </div>
        )}

    </div>
    );
}

export default FormBirthday
